export const VipInfoApi = 'wx/wxvipinfo/' // 微信用户VIP信息
export const RepairServiceOrderApi = 'wx/wechatrepairserviceorder/' // 服务单消费记录
export const SalesOrderApi = 'wx/wechatsalesorder/' //充值单消费记录
export const VipMemberRechargeApi = 'wx/wechatvipmemberrecharge/' // 车品消费记录
export const UserCardApi = 'wx/wechatusercard/' // 用户的储值卡套餐卡
export const MaintenanceApi = 'wx/wechatmaintenance/' // 用户的保养记录
export const RepairRemindApi = 'wx/repairremind/' // 会员的保养提醒
export const ComplaintApi = 'wx/complaint/' // 用户的投诉建议
export const BookingApi = 'wx/wechatbooking/' // 会员预约记录
export const UserCarApi = 'wx/wechatusercar/' // 会员车辆记录
export const CouponApi = 'wx/wechatcoupon/' // 会员优惠券记录
export const VoucherApi = 'wx/wechatredemptionvoucher/' // 会员兑换券记录
export const UserBindApi = 'wx/wechatuserbind/' // 会员绑定店铺
export const CouponTransferApi = 'wx/wechatcoupontransfer/' // 优惠券转赠
export const VoucherTransferApi = 'wx/wechatredemptionvouchertransfer/' // 兑换券转赠
// export const AssertApi = 'wx/assert/' // 兑换券转赠